var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkIconCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2409 11.0002C15.2409 13.8258 14.7193 16.3598 13.8971 18.1686C13.0544 20.0226 11.9924 20.9305 10.9999 20.9305C10.0073 20.9305 8.9453 20.0226 8.1026 18.1686C7.28041 16.3598 6.75879 13.8258 6.75879 11.0002C6.75879 8.17448 7.28041 5.64051 8.1026 3.8317C8.9453 1.97775 10.0073 1.06982 10.9999 1.06982C11.9924 1.06982 13.0544 1.97775 13.8971 3.8317C14.7193 5.64051 15.2409 8.17448 15.2409 11.0002Z",
    stroke: "#0E0333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9993 15.2413C8.17366 15.2413 5.6397 14.7197 3.83089 13.8975C1.97694 13.0548 1.06901 11.9928 1.06901 11.0002C1.06901 10.0076 1.97694 8.94567 3.83089 8.10296C5.6397 7.28078 8.17366 6.75915 10.9993 6.75915C13.825 6.75915 16.359 7.28078 18.1678 8.10296C20.0218 8.94567 20.9297 10.0076 20.9297 11.0002C20.9297 11.9928 20.0218 13.0548 18.1678 13.8975C16.359 14.7197 13.825 15.2413 10.9993 15.2413Z",
    stroke: "#0E0333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIconCard);
export default __webpack_public_path__ + "static/media/link-icon-card.fb0f19b677199cc49b89721502c924be.svg";
export { ForwardRef as ReactComponent };